import { DataBaseModelInterface } from '@solcre-org/core';
import { DateUtility } from '@solcre-org/core-ui';

export class AuditLogChangeModel implements DataBaseModelInterface {
  constructor(
    public id?: any,
    public field?: string,
    public oldValue?: string,
    public newValue?: string
  ) {}

  public fromJSON(json: any): AuditLogChangeModel {
    if (json) {
      this.id = json.id;
      this.field = json.field;

      if (typeof json.oldValue === 'object') {
        this.oldValue = json.oldValue.label;
      } else {
        this.oldValue = json.oldValue;
      }
      if (typeof json.newValue === 'object') {
        this.newValue = json.newValue.label;
      } else {
        this.newValue = json.newValue;
      }
    }
    return this;
  }

  public fromJSONList(json: any): AuditLogChangeModel[] {
    if (json) {
      return json.map((element: any) =>
        new AuditLogChangeModel().fromJSON(element)
      );
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      field: this.field,
      oldValue: this.oldValue,
      newValue: this.newValue,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.id ?? '';
  }
}
